export default {
  formSubmitHost: 'https://contact.apps-api.instantpage.test-secureserver.net',
  generateUrlHost: 'https://url-generator.apps.test-secureserver.net',
  contactsHost: 'https://contacts.test-godaddy.com',
  conversationsWebHost: 'https://conversations.test-godaddy.com'
};
